<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-text-field v-model="searchValue" label="搜尋"
                      :color="Theme.GREEN" placeholder="查詢公告"></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn class="mr-2" :color="Theme.GREEN" dark @click.prevent="searchEvent">搜尋</v-btn>
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <v-spacer></v-spacer>
        <v-btn style="float: right;" :color="Theme.PINK" dark @click.prevent="addNew">新增</v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"
                    @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>

    <news-detail :title="editView.title" :visible="editView.visible"
                 :item-detail="editView.item"
                 :show-cancel="editView.showCancel"
                 @cancelEvent="editView.cancelEvent"
                 @confirmEvent="editView.confirmEvent">
    </news-detail>
  </v-container>
</template>

<script>
import TableView from "@/components/TableView";

import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import NewsDetail from "@/pages/news/NewsDetail";

export default {
  name: "news",
  components: {
    NewsDetail,
    TableView
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      searchValue:'',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
    };
  },
  created() {
    this.loadData();
  },
  computed:{
    ...mapGetters([]),
    getColumnKeys(){
      return [
        { value:'edit', text:'編輯' , isEvent: true, color: this.Theme.GREEN, sortable: false },
        { value:'title', text:'標題', sortable: true },
        { value:'imageUrl', text:'圖片', sortable: true , isImage: true,},
        { value:'preview', text:'簡介', sortable: false },
        { value:'status', text:'是否顯示', sortable: false , options: [
            { key: 0, value: '否'},
            { key: 1, value: '是'}
          ]},
        { value:'createdDate', text:'建立時間', sortable: false },
        { value:'updatedDate', text:'最後更新時間', sortable: false },
        // { value:'delete', text:'刪除' , isEvent: true, color: this.Theme.YELLOW, sortable: false },
      ]
    }
  },
  methods:{
    ...mapActions(['getNewsList','deleteNewsInfo']),
    async loadData(){
     try {
       this.loading = true;
       const res = await this.getNewsList({
         pageIndex: this.pagination.page,
         limit: this.pagination.itemsPerPage,
       });
       const result = res.data;

       if (result.statusCode === 0){
         this.list = result.data.list;
         this.pagination.totalItems = result.data.header.totalCount;

         console.log(`getNewsList ${JSON.stringify(res.data.data.list)}`);
       }
       this.loading = false;
     }catch (e) {
       console.log(`getNewsList error `, e);
       this.loading = false;
     }
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page){
      this.pagination.page = page.page;
      this.pagination.itemsPerPage = page.itemsPerPage;
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell){
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'delete'){
        this.showAlert({
          title: '提示',
          content: '是否確定要刪除此消息？',
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          }
        });
      } else {
        this.editView.title = cell.key === 'add' ? '新增消息':'修改消息'
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = ()=>{
          this.editView.visible = false;
        }
        this.editView.confirmEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        }
      }

    },
    searchEvent(){
      this.loadData();
    },
    reset(){
      this.searchValue = '';
      this.loadData();
    },
    async deleteEvent(item){
      const res = await this.deleteNewsInfo({
        newsId: item.newsId,
      });

      if (res.data.code === 0){
        this.reset();
      }
    },
    addNew(){
      this.cellEvent({
        key: 'add',
        item: {
          newsId: this.uuid.v4(),
          title:'',
          preview:'',
          content:'',
          status: 0,
          imageUrl:'',
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
